import { render, staticRenderFns } from "./mukerrerfiskontrol.vue?vue&type=template&id=787ffbcc&"
import script from "./mukerrerfiskontrol.vue?vue&type=script&lang=js&"
export * from "./mukerrerfiskontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports